module.exports.ACHIEVEMENTS_CONSTANTS = {
    RECEIVE_ALL_ACHIEVEMENTS : "RECEIVE_ALL_ACHIEVEMENTS",
    CREATE_ACHIEVEMENT: "CREATE_ACHIEVEMENT",
    UPDATE_ACHIEVEMENT: "UPDATE_ACHIEVEMENT",
    DELETE_ACHIEVEMENT: "DELETE_ACHIEVEMENT",
    LIKE_ACHIEVEMENT: "LIKE_ACHIEVEMENT"
}

module.exports.AUTH_CONSTANTS = {
    AUTH: "AUTH",
    LOGOUT: "LOGOUT",
    SIGNUP: "SIGNUP",
    SIGNIN: "SIGNIN"
}